export default __webpack_public_path__ + "static/N0269-d3fa7ab654785f15cf612d9c677f7b3d.png";